import React from 'react';
import { motion } from 'framer-motion';

const FamilyCard = ({ id, accentColor, dotColor, borderColor, bgGlow, tag, name, origin, role, body, quote, quoteSource }) => (
  <section id={id} className={`py-24 border-t border-white/5 relative overflow-hidden`}>
    <div className={`absolute inset-0 ${bgGlow}`}></div>
    <div className="max-w-5xl mx-auto px-6 lg:px-8 relative z-10">
      <motion.div
        initial={{ opacity: 0, y: 40 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        className="mb-12"
      >
        <div className="flex items-center gap-3 mb-4">
          <span className={`w-3 h-3 rounded-full flex-shrink-0 ${dotColor} shadow-lg`}></span>
          <span className={`text-xs font-semibold uppercase tracking-widest ${accentColor}`}>{tag}</span>
        </div>
        <h2 className="text-3xl md:text-5xl font-display font-bold text-white mb-2">{name}</h2>
        <p className="text-gray-500 text-sm tracking-wide">{origin}</p>
        <div className={`h-1 w-20 ${dotColor} mt-5 rounded-full`}></div>
      </motion.div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-10 items-start">
        <motion.div
          initial={{ opacity: 0, x: -30 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          className="space-y-5"
        >
          {body.map((para, i) => (
            <p key={i} className="text-gray-300 leading-relaxed text-[1.05rem]" dangerouslySetInnerHTML={{ __html: para }} />
          ))}
        </motion.div>

        <motion.div
          initial={{ opacity: 0, x: 30 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          className={`bg-brand-dark border ${borderColor} rounded-2xl p-8 flex flex-col justify-between h-full`}
        >
          <div>
            <span className={`text-4xl font-display ${accentColor} leading-none`}>"</span>
            <p className="text-gray-200 italic leading-relaxed text-lg mt-2 mb-6">{quote}</p>
          </div>
          <p className={`text-sm font-medium ${accentColor}`}>— {quoteSource}</p>
        </motion.div>
      </div>
    </div>
  </section>
);

export default FamilyCard;